// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.token-balance {
  margin-top: 1.25rem;
  padding: 20px;
  border-radius: 20px;
  background-color: rgba(43, 7, 77, 0.85);
  box-shadow: 0 0 14px 0 #ff2481;
  min-height: 230px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center; }
  .token-balance__wrapper {
    display: flex;
    flex-direction: column;
    align-items: center; }
  .token-balance__content-row {
    display: flex;
    justify-content: center;
    align-items: center; }
  .token-balance__header {
    display: flex;
    align-items: center;
    width: 100%; }
    @media screen and (max-width: 768px) {
      .token-balance__header {
        justify-content: center; } }
  .token-balance__image {
    position: absolute;
    height: 200px;
    width: 200px;
    bottom: 14px;
    right: -10px; }
    @media screen and (max-width: 991px) {
      .token-balance__image {
        right: -90px; } }
    @media screen and (max-width: 768px) {
      .token-balance__image {
        right: 40px; } }
    @media screen and (max-width: 576px) {
      .token-balance__image {
        right: -90px; } }
  .token-balance__body {
    display: flex;
    gap: 30px;
    flex-direction: column;
    text-align: center; }
  .token-balance__title {
    font-family: "Outfit", sans-serif;
    font-size: 24px;
    font-weight: 600;
    color: #ffffff; }
  .token-balance__subtitle {
    gap: 7px;
    display: flex;
    justify-content: space-between;
    font-family: "Outfit", sans-serif;
    font-size: 28px;
    font-weight: 400;
    color: #ffffff; }
  .token-balance__button-row {
    margin-top: 10px !important;
    display: flex;
    justify-content: center;
    align-items: center; }
    @media screen and (max-width: 768px) {
      .token-balance__button-row {
        flex-direction: column; } }
  .token-balance__button-col {
    display: flex;
    justify-content: center; }
  .token-balance__button {
    transition: all 0.3s ease;
    background-color: #ff2481;
    color: #ffffff;
    padding: 0.5em 1em;
    border: 1.85px solid #e02574;
    cursor: pointer;
    border-radius: 6px;
    color: #ffffff;
    font-family: "Outfit", sans-serif;
    font-size: 1em;
    font-weight: 600; }
    .token-balance__button:hover {
      background-color: #e02574; }
`, "",{"version":3,"sources":["webpack://./src/components/TokenComponents/TokenBalance/style.scss","webpack://./src/styles/mixins/mixins.scss","webpack://./src/styles/variables/_variables.scss"],"names":[],"mappings":"AAGA;ECII,mBAAmB;EACnB,aAAa;EACb,mBCOuB;EDNvB,uCCT0B;EDU1B,8BCEqC;EDDrC,iBDRyB;EAC3B,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB,EAAA;EAEvB;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAA;EAGrB;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB,EAAA;EAGrB;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW,EAAA;IAEX;MALF;QAMI,uBAAuB,EAAA,EAE1B;EAED;IACE,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,YAAY,EAAA;IAEZ;MAPF;QAQI,YAAY,EAAA,EAUf;IAPC;MAXF;QAYI,WAAW,EAAA,EAMd;IAHC;MAfF;QAgBI,YAAY,EAAA,EAEf;EAED;IACE,aAAa;IACb,SAAS;IACT,sBAAsB;IACtB,kBAAkB,EAAA;EAGpB;IC1DE,iCAAiC;IACjC,eD0D4B;ICzD5B,gBDyDiC;IACjC,cE1DqB,EAAA;EF6DvB;IACE,QAAQ;IACR,aAAa;IACb,8BAA8B;IClE9B,iCAAiC;IACjC,eDkE4B;ICjE5B,gBDiEiC;IACjC,cElEqB,EAAA;EFqEvB;IACE,2BAA2B;IAC3B,aAAa;IACb,uBAAuB;IACvB,mBAAmB,EAAA;IAEnB;MANF;QAOI,sBAAsB,EAAA,EAEzB;EAED;IACE,aAAa;IACb,uBAAuB,EAAA;EAGzB;IACE,yBAAyB;ICzEzB,yBCKgC;IDJhC,cCdqB;IDerB,kBAAkB;IAClB,4BCC4B;IDA5B,eAAe;IACf,kBAAkB;IDsElB,cExFqB;IDFrB,iCAAiC;IACjC,cD0F2B;ICzF3B,gBDyFgC,EAAA;IAJjC;MChEK,yBCFuB,EAAA","sourcesContent":["@import \"../../../styles/variables/variables\";\n@import \"../../../styles/mixins/mixins\";\n\n.token-balance {\n  @include tokenSection(230px);\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n\n  &__wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  &__content-row {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  &__header {\n    display: flex;\n    align-items: center;\n    width: 100%;\n\n    @media screen and (max-width: 768px) {\n      justify-content: center;\n    }\n  }\n\n  &__image {\n    position: absolute;\n    height: 200px;\n    width: 200px;\n    bottom: 14px;\n    right: -10px;\n\n    @media screen and (max-width: 991px) {\n      right: -90px;\n    }\n\n    @media screen and (max-width: 768px) {\n      right: 40px;\n    }\n\n    @media screen and (max-width: 576px) {\n      right: -90px;\n    }\n  }\n\n  &__body {\n    display: flex;\n    gap: 30px;\n    flex-direction: column;\n    text-align: center;\n  }\n\n  &__title {\n    @include tokenFontMixin(24px, 600);\n    color: $tokenWhiteColor;\n  }\n\n  &__subtitle {\n    gap: 7px;\n    display: flex;\n    justify-content: space-between;\n    @include tokenFontMixin(28px, 400);\n    color: $tokenWhiteColor;\n  }\n\n  &__button-row {\n    margin-top: 10px !important;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    @media screen and (max-width: 768px) {\n      flex-direction: column;\n    }\n  }\n\n  &__button-col {\n    display: flex;\n    justify-content: center;\n  }\n\n  &__button {\n    transition: all 0.3s ease;\n    @include tokenMainButton($tokenWhiteColor, $tokenButtonBackgroundColor);\n    color: $tokenWhiteColor;\n    @include tokenFontMixin(1em, 600);\n  }\n}\n","@mixin tokenFontMixin($fontSize, $fontWeight) {\n    font-family: \"Outfit\", sans-serif;\n    font-size: $fontSize;\n    font-weight: $fontWeight;\n}\n\n@mixin tokenSection($height) {\n    margin-top: 1.25rem;\n    padding: 20px;\n    border-radius: $tokenContainerRadius;\n    background-color: $tokenContainerBackgroundColor;\n    box-shadow: $tokenContainerShadow;\n    min-height: $height;\n}\n\n@mixin tokenMainButton($color, $backgroundColor) {\n    background-color: $backgroundColor;\n    color: $color;\n    padding: 0.5em 1em;\n    border: 1.85px solid $tokenButtonBorderColor;\n    cursor: pointer;\n    border-radius: 6px;\n\n    &:hover {\n        background-color: $tokenButtonHoverColor;\n    }\n}\n\n@mixin tokenOutlineButton($color, $backgroundColor) {\n    background-color: $backgroundColor;\n    color: $color;\n    padding: 0.5em 1em;\n    border: 2px solid $tokenButtonBackgroundColor;\n    cursor: pointer;\n    border-radius: 6px;\n\n    &:hover {\n        background-color: $tokenButtonHoverColor;\n    }\n}\n","// Main Colors\n$tokenBackgroundColor: #2b074d;\n$tokenContainerBackgroundColor: rgba($tokenBackgroundColor, 0.85);\n$tokenWhiteColor: #ffffff;\n$tokenBlackColor: #000000;\n$tokenPlaceholderColor: #757179;\n\n// Status Colors\n$tokenVerifyStatus: #60ffa8;\n$tokenPendingStatus: #ffdb81;\n$tokenErrorStatus: #ff0000;\n\n// SHADOW\n$tokenContainerShadow: 0 0 14px 0 #ff2481;\n\n// BORDER\n$tokenContainerRadius: 20px;\n$tokenContainerBorderColor: #340c5a;\n\n// BUTTON\n$tokenButtonBorderColor: #e02574;\n$tokenButtonBackgroundColor: #ff2481;\n$tokenButtonHoverColor: #e02574;\n\n// COIN BACKGROUND\n$tokenCoinBackground: #ededed;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
